import { EventBus } from '@/main';

export interface PinToggleResult {
  pinned: boolean;
  capped: boolean;
  error: boolean;
}

/**
 * Map the result of PinnedReportsModule.togglePinReport to a snackbar.
 * Shared by the report page and the My Reports list so the wording and
 * cap message stay in one place.
 */
export function emitPinReportSnackbar(result: PinToggleResult): void {
  if (result.error) {
    EventBus.$emit('show-snackbar', { message: 'Failed to update pinned reports', color: 'error' });
  } else if (result.capped) {
    EventBus.$emit('show-snackbar', { message: 'You can pin up to 10 reports', color: 'warning' });
  } else {
    EventBus.$emit('show-snackbar', {
      message: result.pinned ? 'Report pinned to menu' : 'Report unpinned from menu',
      color: 'success',
    });
  }
}
